import React from 'react'
import { Button, Grid, Typography } from '@mui/material'
import { ArrowBackIos } from '@mui/icons-material'
import i18n from 'i18n/index'

type Props = {
  message: string
  finishRecoverPassword: () => void
  email?: string
}

const RecoverSuccess = (props: Props) => {
  const { finishRecoverPassword, email = '', message } = props

  return (
    <Grid container>
      <Grid item flexDirection="column" xs={12}>
        <Typography color="text.secondary" variant="h4">
          {message}
        </Typography>
        <Typography color="text.secondary" variant="h5" marginBottom="10px">
          {email}
        </Typography>
      </Grid>
      <Grid item xs={12} marginTop="30px">
        <Button
          variant="text"
          size="large"
          color="secondary"
          onClick={finishRecoverPassword}
          startIcon={<ArrowBackIos sx={{ fontSize: '16px !important' }} />}
        >
          {i18n.t('backToHome')}
        </Button>
      </Grid>
    </Grid>
  )
}

export default RecoverSuccess
